import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { fl } from "@/lib/finI18n";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Download, Loader2, FileQuestion } from "lucide-react";

export function AttachmentPreview({ att, onClose }) {
  const { lang } = useI18n();
  const [blob, setBlob] = useState(null);

  useEffect(() => {
    if (!att) return undefined;
    let url = null;
    let alive = true;
    api.get(`/attachments/${att.id}/download`, { responseType: "blob" }).then((res) => {
      const type = att.content_type || res.data.type || "application/octet-stream";
      url = URL.createObjectURL(new Blob([res.data], { type }));
      if (alive) setBlob({ url, type });
    }).catch(() => toast.error("Gagal membuka lampiran"));
    return () => { alive = false; if (url) URL.revokeObjectURL(url); setBlob(null); };
  }, [att]);

  const name = att?.original_filename || "";
  const isImg = blob && (blob.type.startsWith("image/") || /\.(png|jpe?g|webp|gif)$/i.test(name));
  const isPdf = blob && (blob.type.includes("pdf") || /\.pdf$/i.test(name));
  const download = () => { const a = document.createElement("a"); a.href = blob.url; a.download = name; a.click(); };

  return (
    <Dialog open={!!att} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-4xl w-[95vw] p-0 gap-0 overflow-hidden" data-testid="attachment-preview-modal">
        <DialogHeader className="px-5 py-3 border-b border-border">
          <DialogTitle className="text-sm font-medium truncate pr-8" data-testid="attachment-preview-name">{fl("preview", lang)} · {name}</DialogTitle>
        </DialogHeader>
        <div className="h-[72vh] bg-muted/40 flex items-center justify-center">
          {!blob && <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />}
          {isPdf && <iframe src={blob.url} title={name} className="w-full h-full bg-white" data-testid="attachment-preview-frame" />}
          {isImg && <img src={blob.url} alt={name} className="max-h-full max-w-full object-contain" data-testid="attachment-preview-image" />}
          {blob && !isPdf && !isImg && (
            <div className="text-center text-sm text-muted-foreground space-y-2" data-testid="attachment-preview-unsupported">
              <FileQuestion className="h-10 w-10 mx-auto opacity-50" />
              <p>{fl("noPreview", lang)}</p>
            </div>
          )}
        </div>
        <div className="px-5 py-3 border-t border-border flex justify-end">
          <Button size="sm" onClick={download} disabled={!blob} data-testid="attachment-preview-download"><Download className="h-4 w-4 mr-1.5" />{fl("download", lang)}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
